import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface MeResponse extends BackendResponse, User {}

export interface MeParameters extends NextApiParams {}

export const me = withNextApi<MeResponse, MeParameters>("/auth/Me", {
  method: "GET",
});

export interface User {
  id: string;
  name: string;
}
